import request from "@/utils/request"

export function sensorLastData(type) {
  return request.get(`/sensor/${type}`)
}

export function sensorLast30Data(type, params) {
  return request.get(`/sensor/${type}/last30`, {params: params})
}

export function sensorPathData(type, params) {
  return request.get(`/sensor/${type}/path`, {params: params})
}

export function videoLogPage(params) {
  return request.get(`/videoLogs`, {params: params})
}

export function videoLogCreate(data) {
  return request.post(`/videoLogs`, data)
}
